import Views from "qpr-base/app/Views";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import WFSteps from "qpr-base/pages/kpiworkflowsteps";
import React from "react";
import { Route, Switch, useParams, useRouteMatch } from "react-router-dom";
import LandingPage from "./pages/landingpage/index";

import { useCurrentTenant } from "@qpr/client-library/dist/esm";
import usePeriodLevels from "backend/hooks/model/usePeriodLevels";
import AdminTools from "pages/admintools";
import CascadePage from "pages/cascade";
import CompletedTasks from "pages/completedtasks";
import ConfigurableReports from "pages/configurablereports";
import CreateDashboard from "pages/createdashboard";
import Division from "pages/division";
import EditDashboard from "pages/editdashboard";
import ElementTest from "pages/elementtest";
import ExecutiveDashboard from "pages/executivedashboard";
import InitiativeDetails from "pages/initiativedetails";
import Initiatives from "pages/initiatives";
import KPIDetails from "pages/kpidetails";
import KPIs from "pages/kpis";
import KPisAndInitiaivesView from "pages/kpisandinitiatives";
import KPIsAndProjectsManagement from "pages/kpisandprojectsmanagement";
import KPIsForm from "pages/kpisandprojectsmanagementforms/KPIsForm/index";
import ProjectForm from "pages/kpisandprojectsmanagementforms/ProjectForm/ProjectsForm";
import MyDashboardsPage from "pages/mydashboards";
import MyTasks from "pages/mytasks";
import Overview from "pages/overview";
import Perspective from "pages/perspective";
import Playground from "pages/playground/Playground";
import ReportTemplates from "pages/reporttemplates";
import ReportWorkflow from "pages/reportworkflow";
import StrategyMap from "pages/strategymap";
import ViewDashboard from "pages/viewdashboard";
import WorkflowAdmin from "pages/workflowadmin";
import WorkflowConfigs from "pages/workflowconfigs";
import WorkflowInput from "pages/workflowinput";
import Analytics from "pages/analytics";
import useRanges from "qpr-base/hooks/useRangeContext";
import ActionsPage from "pages/actions";
const SamplePage = () => {
  const ctx = useAppContext();
  return (
    <div>
      <WFSteps />
    </div>
  );
};

const SubViews = () => {
  const tenant = useCurrentTenant();
  const ctx = useAppContext();
  const periods = usePeriodLevels();
  return (
    <Views>
      <div style={{ marginTop: "70px" }}>
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/playground`}
          component={Playground}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/elementtest`}
          component={ElementTest}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/corporate`}
          component={StrategyMap}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/cascade`}
          component={CascadePage}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/mytasks`}
          component={MyTasks}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/mydashboards`}
          component={MyDashboardsPage}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/createdashboard`}
          component={CreateDashboard}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/editdashboard`}
          component={EditDashboard}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/editslidetemplatedashboard`}
          component={EditDashboard}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/viewdashboard`}
          component={ViewDashboard}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/workflowconfigs`}
          component={WorkflowConfigs}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/workflowinput`}
          component={WorkflowInput}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/completedtasks`}
          component={CompletedTasks}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/executivedashboard`}
          component={ExecutiveDashboard}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/strategymap/:id?/:meaId?/`}
          component={StrategyMap}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/division/:id?/:meaId?/`}
          component={Division}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/overview/:id?/:meaId?/`}
          component={Overview}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/kpis/:id?/:meaId?/`}
          component={KPIs}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/initiatives/:id?/:meaId?/`}
          component={Initiatives}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/objective/:id?/:meaId?/`}
          component={KPisAndInitiaivesView}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/perspective/:id?/:meaId?/`}
          component={Perspective}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/kpidetails/:id?/:meaId?/`}
          component={KPIDetails}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/initiativedetails/:id?/:meaId?/`}
          component={InitiativeDetails}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/reporttemplates`}
          component={ReportTemplates}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/configurablereports`}
          component={ConfigurableReports}
        />
		  <Route
			  path={`/${tenant.symbol}/${ctx.modelId}/reportworkflow`}
			  component={ReportWorkflow}
		  />
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/workflowadmin`}
          component={WorkflowAdmin}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/admintools`}
          component={AdminTools}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/kpisandprojectsmanagement`}
          component={KPIsAndProjectsManagement}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/kpisform`}
          component={KPIsForm}
        />
        <Route
          path={`/${tenant.symbol}/${ctx.modelId}/projectsform`}
          component={ProjectForm}
        />
		<Route
          path={`/${tenant.symbol}/${ctx.modelId}/analytics`}
          component={Analytics}
        />
	  <Route
		  path={`/${tenant.symbol}/${ctx.modelId}/actions/:meaId?`}
		  component={ActionsPage}
	  />
      </div>
    </Views>
  );
};

const Routes = () => {
  const { path } = useRouteMatch();
  const tenant = useCurrentTenant();
  const ctx = useAppContext();
  const params = useParams<{
    id: string;
    meaId: string;
    period: string;
    model: string;
    module: string;
  }>();
  // initialize
  React.useEffect(() => {
    if (tenant.symbol && tenant.symbol !== ctx.tenant) {
      ctx.sendValue("tenant", tenant.symbol);
    }
    if (params.model !== ctx.modelId) {
      if (params.model) {
        ctx.sendValue("model", params.model);
      } else {
        ctx.sendValue("model", ctx.modelId);
      }
    }
    if (!ctx.period) {
      const currentDate = new Date();
      ctx.sendValue("period", currentDate.getFullYear().toString());
    }
  }, [params.model, ctx.period, ctx.modelId, tenant.symbol]);

  useRanges();
  return (
    <Switch>
      <Route path={`/${tenant.symbol}/`} exact component={LandingPage} />
      <Route path={`/${tenant.symbol}/:model/`} exact component={LandingPage} />
      <Route path={`${path}/`} component={LandingPage} exact />
      <Route
        path={`/${tenant.symbol}/${ctx.modelId}/landingpage/:meaId?/`}
        component={LandingPage}
      />
      <Route path={`${path}/:model/:id/:meaId?/`} component={SubViews} />
    </Switch>
  );
};

export default Routes;
